import Vue from "vue";
import Router from "vue-router";

import KontoLibrus from "./views/KontoLibrus.vue";
import AplikacjaMobilna from "./views/AplikacjaMobilna";
import Sklep from "./views/Sklep";
import Indywidualni from "./views/Indywidualni";
import Regulaminy from "./views/Regulaminy";
import Nauczyciel from "./views/Nauczyciel";
import Tlumaczenia from "./views/pomoc/Tlumaczenia";
import Help from "./components/Help";
import HelpDetail from "./components/HelpDetail";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "KontoLibrus",
      component: KontoLibrus,
    },
    {
      path: "/nauczyciel",
      name: "NauczycielLibrus",
      component: Nauczyciel,
    },
    {
      path: "/aplikacjamobilna",
      name: "AplikacjaMobilna",
      component: AplikacjaMobilna,
    },
    {
      path: "/mobilnedodatki",
      redirect: "/aplikacjamobilna",
    },
    {
      path: "/sklep",
      name: "Sklep",
      component: Sklep,
    },
    {
      path: "/indywidualni",
      name: "Indywidualni",
      component: Indywidualni,
    },
    {
      path: "/pomoc",
      redirect: "/pomoc/konto-librus",
    },
    {
      path: "/pomoc/:module",
      name: "Pomoc",
      component: Help,
    },
    {
      path: "/pomoc/:module/:paragraph",
      name: "Pomoc-Detal",
      component: HelpDetail,
    },
    {
      path: "/pomoc/tlumaczenie/:lang/:platform",
      name: "Pomoc-Tlumaczenie",
      component: Tlumaczenia,
    },
    {
      path: "/regulaminy",
      name: "Regulaminy",
      component: Regulaminy,
    },
    {
      path: "*",
      name: "404",
      component: KontoLibrus,
    },
  ],
});
